import cn from "classnames";
import { FC, useState } from "react";
import { useForm } from "react-hook-form";
import styles from "./Whale.module.scss";
import { Form } from "./components/form";
import { TableHeader, TableItems, TableRow } from "./components/table";
import { Pagination, FilterButton, Content } from "./components";
import HideButton from "./components/HideButton";
import WalletButton from "./components/WalletButton";

const Whale: FC = () => {
    const { register, handleSubmit, setValue, formState } = useForm();
    const [currentPage, setCurrentPage] = useState(1);
    const [isFormVisible, setIsFormVisible] = useState(true);

    return (
        <Content>
            <HideButton isVisible={isFormVisible} setIsVisible={setIsFormVisible} />
            <div className={cn(styles.leftHolder, { [styles.hidden]: !isFormVisible })}>
                <Form
                    formState={formState}
                    setValue={setValue}
                    register={register}
                    onSubmit={handleSubmit((data) => console.log(data))}
                />
            </div>
            <div className={cn(styles.block, styles.history)}>
                <div className={styles.blockContent}>
                    <TableHeader>
                        <WalletButton />
                        <FilterButton />
                    </TableHeader>
                    <TableItems>
                        <TableRow
                            date="1 Jan"
                            wallet="qwe"
                            from="200 TON"
                            amount="800 USDT"
                            link="/"
                            transactionType="Swap tokens"
                        />
                        <TableRow
                            date="1 Jan"
                            wallet="asd"
                            from="200 TON"
                            amount="125 USDT"
                            link="/"
                            transactionType="Received token"
                        />
                        <TableRow
                            date="1 Jan"
                            wallet="zxc"
                            from="200 TON"
                            amount="300 USDT"
                            link="/"
                            transactionType="Received token"
                        />
                        <TableRow
                            date="1 Jan"
                            wallet="rty"
                            from="200 TON"
                            amount="550 USDT"
                            link="/"
                            transactionType="Received token"
                        />
                        <TableRow
                            date="1 Jan"
                            wallet="ghj"
                            from="200 TON"
                            amount="100 USDT"
                            link="/"
                            transactionType="Received token"
                        />
                        <TableRow
                            date="1 Jan"
                            wallet="bnm"
                            from="200 TON"
                            amount="50 USDT"
                            link="/"
                            transactionType="Received token"
                        />
                        <TableRow
                            date="1 Jan"
                            wallet="nmp"
                            from="200 TON"
                            amount="750 USDT"
                            link="/"
                            transactionType="Received token"
                        />
                    </TableItems>
                </div>
                <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} />
            </div>
        </Content>
    );
};

export default Whale;
